/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PosItemVarianceOptionModel } from './posItemVarianceOptionModel';


export interface PosItemVarianceModel { 
    mandatory?: boolean;
    maxPick?: number;
    options?: Array<PosItemVarianceOptionModel>;
    position?: number;
    prepareType?: PosItemVarianceModel.PrepareTypeEnum;
    title?: string;
    type?: string;
}
export namespace PosItemVarianceModel {
    export type PrepareTypeEnum = 'DINE_IN' | 'TAKE_AWAY';
    export const PrepareTypeEnum = {
        DineIn: 'DINE_IN' as PrepareTypeEnum,
        TakeAway: 'TAKE_AWAY' as PrepareTypeEnum
    };
}


